import { render, staticRenderFns } from "./report-service-workreport.vue?vue&type=template&id=2848aa1a&"
import script from "./report-service-workreport.vue?vue&type=script&lang=js&"
export * from "./report-service-workreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports